import { FC } from 'react'

import { CourseOutlineTaskTypeEnum } from 'packages/sdks-next/growp'

import { AttachmentFile } from '@/features/types'

import { UploadPdf } from './UploadPdf'
import { UploadVideo } from './UploadVideo'

export type UploadTaskFileProps = {
  setFile: (file: AttachmentFile | undefined) => void
  file: AttachmentFile | undefined
}

/**
 * 上传任务文件组件
 *
 * @param param0 - 参数
 * @param param0.type - 任务类型
 * @param param0.setFile - 设置表单文件
 * @param param0.file - 表单文件
 * @returns 上传任务文件组件
 */
export const UploadTaskFile: FC<{
  type: CourseOutlineTaskTypeEnum
  setFile: (file: AttachmentFile | undefined) => void
  file: AttachmentFile | undefined
}> = ({ type, setFile, file }) => {
  switch (type) {
    case CourseOutlineTaskTypeEnum.Video:
      return (
        <UploadVideo
          setFile={setFile}
          file={file}
        />
      )
    case CourseOutlineTaskTypeEnum.Pdf:
      return (
        <UploadPdf
          setFile={setFile}
          file={file}
        />
      )
    default:
      return null
  }
}
